module.exports = __webpack_public_path__ + "static/media/clear.36175f3d.png";